import axios from "axios";
import { store } from "../redux";
import { LOGOUT } from "../redux/actionTypes";

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const { response } = error;
      if (response) {
        const { status, data } = response;
        // Check for 400 Token invalid
        if (status === 400 && data?.message === "Token invalid") {
          store.dispatch({ type: LOGOUT });
          window.location.href = "/login";
          return Promise.reject(error);
        }
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
